import React, { useMemo } from "react";
import * as Scrivito from "scrivito";
import { priceToString } from "utils/priceToString";
import { useTranslate } from "hooks";
import { EllipsisWithTooltip } from "components/EllipsisWithTooltipText";

export const ProductListTableRow = Scrivito.connect(
  ({ product, fetchingProductList }) => {
    const {
      title,
      presentation,
      quantity,
      unitPrice,
      totalPrice = null,
      priceGroup = null,
    } = product;
    const translate = useTranslate();

    const { unitPriceString, totalPriceString } = useMemo(
      () => ({
        unitPriceString: unitPrice
          ? priceToString({
              price: unitPrice,
              noPriceText: translate("NO_PRICE"),
            })
          : null,
        totalPriceString: totalPrice
          ? priceToString({
              price: totalPrice,
              noPriceText: translate("NO_PRICE"),
            })
          : null,
      }),
      [unitPrice, translate, totalPrice],
    );

    return (
      <>
        <td style={{ width: "20%" }}>
          <div className="text-gray-700 fw-bold text-truncate mw-100">
            <EllipsisWithTooltip text={title} />
          </div>
        </td>
        <td
          className="text-break text-nowrap overflow-hidden text-truncate"
          style={{ width: "25%" }}
        >
          <EllipsisWithTooltip text={presentation} />
        </td>
        <td style={{ width: "10%" }}>{quantity}</td>
        {fetchingProductList ? (
          <>
            <td style={{ width: "15%" }}>
              <div className="shortloadingLine col-8 rounded"></div>
            </td>
            <td style={{ width: "15%" }}>
              <div className="shortloadingLine col-8 rounded"></div>
            </td>
            <td style={{ width: "15%" }}>
              <div className="shortloadingLine col-8 rounded"></div>
            </td>
          </>
        ) : (
          <>
            <td style={{ width: "15%" }}>{unitPriceString}</td>
            <td className="text-break" style={{ width: "15%" }}>
              {totalPriceString}
            </td>
            <td
              className="text-break text-nowrap overflow-hidden text-truncate"
              style={{ width: "15%" }}
            >
              {priceGroup}
            </td>
          </>
        )}
      </>
    );
  },
);
